if (!customElements.get('product-addon')) {
  customElements.define(
    'product-addon',
    class ProductAddon extends HTMLElement {
      get input() {
        return this.querySelector('input[data-addon-variant-id]');
      }

      get buttons() {
        return Array.from(this.querySelectorAll('.product-addon__button'));
      }

      connectedCallback() {
        if (!this.input) return;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this), { signal }));
        this.input.addEventListener('change', this.onInputChange.bind(this), { signal });
        this.input.addEventListener('focus', () => setTimeout(() => this.input.select()), { signal });

        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onButtonClick(event) {
        event.preventDefault();

        if (event.currentTarget.name === 'plus') {
          this.input.stepUp();
        } else {
          this.input.stepDown();
        }

        this.update();
      }

      onInputChange() {
        const max = this.input.max ? parseInt(this.input.max) : Infinity;
        const value = parseInt(this.input.value) || 0;

        this.input.value = Math.min(Math.max(value, 0), max);
        this.update();
      }

      update() {
        const value = parseInt(this.input.value) || 0;

        this.querySelector('button[name="minus"]')?.toggleAttribute('disabled', value <= 0);
        this.querySelector('button[name="plus"]')?.toggleAttribute('disabled', this.input.max !== '' && value >= parseInt(this.input.max));
        this.toggleAttribute('data-selected', value > 0);
      }

      reset() {
        if (!this.input) return;

        this.input.value = 0;
        this.update();
      }
    }
  );
}
